module.exports = __webpack_public_path__ + "img/profile.f5e1d297.svg";